import styled from '@emotion/styled';

export const TrustContentWrapper = styled.section`
  margin: 60px 0;
  p {
    font-size: 14px;
    line-height: 20px;
  }
`;
